import type {CanvasMeetingSummaryBlock} from '../types';
import {MarkdownRenderer} from '../../markdown-renderer';
import type {BlockRendererProps} from './types';

export const MeetingSummaryBlock = ({
  block,
}: BlockRendererProps<CanvasMeetingSummaryBlock>) => {
  return (
    <div className="py-6">
      {block.body && (
        <MarkdownRenderer
          content={block.body}
          className="canvas-prose max-w-none"
        />
      )}
    </div>
  );
};

export const meetingSummaryBlockConfig = {
  component: MeetingSummaryBlock,
  isEmpty: (block: CanvasMeetingSummaryBlock) => !block.body?.trim(),
};
